import { RetrainHistory } from '@/common/model/recommend/recommendation'

export const RetrainApiPath = {
  RETRAIN_MODELS: '/api/admin/retrain', // POST Retrain Models
  GET_RETRAIN_HISTORY: '/api/sites/{site_id}/retrain-history', // GET Get Retrain History
  MARK_RETRAIN_TIMEOUT: '/api/sites/{site_id}/retrain-history/{history_id}/timeout', // POST Mark Retrain Timeout
  CLEANUP_STUCK_RETRAIN: '/api/sites/{site_id}/retrain-history/cleanup-stuck' // POST Cleanup Stuck Retrain
}

export type RetrainApiPath = (typeof RetrainApiPath)[keyof typeof RetrainApiPath]

export interface RetrainModelsVars {
  site_id?: number
}

export interface GetRetrainHistoryVars {
  site_id: number
}

export interface MarkRetrainTimeoutVars {
  site_id: number
  history_id: number
}

export interface CleanupStuckRetrainVars {
  site_id: number
}

export interface RetrainModelsResponse {
  ok: boolean
  history_id?: number
}

export type GetRetrainHistoryResponse = RetrainHistory[]

export interface MarkRetrainTimeoutResponse {
  ok: boolean
}

export interface CleanupStuckRetrainResponse {
  ok: boolean
  cleaned: number
}
